import type { StaticLayoutSlide } from "@/ui/static-layout";

import { randomize } from "@/utilities/array";

/**
 * Generate an array of number 1-10 in a random order
 */
export const getCarouselSlides = () => {
  const slides = Array.from({ length: 10 }, (_, i): StaticLayoutSlide => {
    const key = i + 1;
    return { key, src: `/images/login/${key}.png` };
  });

  return randomize(slides);
};
